import { DataLayer } from '@grandvisionhq/analytics';
import { isSubscriptionPurchase } from '../../../types/typeguards.js';

const SUBSCRIPTION_EVENT = 'subscription_interaction';
const SUBSCRIPTION_FEATURE = 'subscription';
const pushDeliveryIntervalSelectionEvent = (deliveryInterval)=>{
    DataLayer.pushEvent({
        event: SUBSCRIPTION_EVENT,
        site_feature: SUBSCRIPTION_FEATURE,
        interaction_type: 'choose_delivery_interval',
        delivery_interval: deliveryInterval
    });
};
const pushPurchaseTypeSelectionEvent = (purchaseType)=>{
    const interactionType = isSubscriptionPurchase(purchaseType) ? 'choose_subscription' : 'choose_single_purchase';
    DataLayer.pushEvent({
        event: SUBSCRIPTION_EVENT,
        site_feature: SUBSCRIPTION_FEATURE,
        interaction_type: interactionType
    });
};

export { pushDeliveryIntervalSelectionEvent, pushPurchaseTypeSelectionEvent };
//# sourceMappingURL=subscription-events.js.map
